import React, { Component } from "react";
import OptimisedImage from "../components/optimisedImage";
import EmbeddedVideo from "../components/embeddedVideo";
import ReactPlayer from "react-player";
import Modal from "react-modal";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import SignUpBtn from "../components/signup/signup";
import Metatags from "../components/metatags";
import IndustriesSummaryForSoftwarePage from "../content/industriesSummaryForSoftwarePage";
import Footer from "../components/footer";
import Slider from "react-slick";
import trackVideoWatch from "../utils/trackVideoWatch";
import trackButtonClick from "../utils/trackButtonClick";
import _ from "lodash";
import Chillipiperbtn from "../components/Chillipiperbtn";
import GetPageURL from "../components/GetPageURL";
import CountryCheck from "../components/CountryCheck";
import CookieSetter from "../utils/CookieSetter";

class Software extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      chiliIsOpen: false,
      countryName: "",
      countryCode: "",
      country: this.props.match.params.country
        ? this.props.match.params.country
        : "us",
    };
  }

  componentDidMount() {
    this.setIndustries();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.country !== prevProps.match.params.country) {
      this.setState({
        country: this.props.match.params.country
          ? this.props.match.params.country
          : "us",
      });
      this.setIndustries();
      return true;
    }
    // if user is from AUS then we redirect to Tanda
    if (this.state.countryName === "Australia") {
      if (
        window.confirm(
          "In Australia? Check out Tanda.co. Same software, built for Australia."
        )
      ) {
        window.location = "https://www.tanda.co/";
      }
    }
  }

  setIndustries = () => {
    const country = this.props.match.params.country
      ? this.props.match.params.country
      : "us";

    const countryPages = _.find(IndustriesSummaryForSoftwarePage, (data) => {
      return data.country.code === country;
    });
    this.setState({
      industries: countryPages.country.pages,
      isLoading: false,
    });
  };

  openModal = () => {
    this.setState({
      player: true,
      modalIsOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      player: false,
      modalIsOpen: false,
    });
  };

  openChili = () => {
    this.setState({
      chiliIsOpen: true,
    });
  };

  closeChili = () => {
    this.setState({
      chiliIsOpen: false,
    });
  };

  render() {
    const apps = [
      {
        image: "/images/logos/shell.png",
        title: "shell",
      },
      {
        image: "/images/logos/dominos-pizza.png",
        title: "dominos pizza",
      },
      {
        image: "/images/logos/intertek.png",
        title: "intertek",
      },
      {
        image: "/images/logos/the-cheesecake-shop.png",
        title: "the cheescake shop",
      },
      {
        image: "/images/logos/regis-healthcare.png",
        title: "regis healthcare",
      },
      {
        image: "/images/logos/nike.png",
        title: "nike",
      },
      {
        image: "/images/logos/boost-juice.png",
        title: "boost juice",
      },
      {
        image: "/images/logos/outback-steakhouse.png",
        title: "outback steakhouse",
        class: "transform scale-150",
      },
    ];

    const settings = {
      slidesToShow: 5,
      initialSlide: 1,
      centerMode: true,
      mobileFirst: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      dotsClass: "circle__slick__dots",
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            autoplaySpeed: 2000,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 425,
          settings: {
            slidesToShow: 1,
            autoplaySpeed: 1500,
          },
        },
      ],
    };

    return (
      <>
        <CountryCheck
          pageTo="/uk"
          history={this.props.history}
          country={this.state.country}
        />
        <CookieSetter location={this.props.location} />
        <GetPageURL url={this.props.location.pathname} />
        <div className="overflow-hidden">
          <Modal
            ariaHideApp={false}
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            className="modal__content modal__video px-2 lg:px-8 py-8"
            overlayClassName="modal__overlay"
            contentLabel="Redirect Notice"
          >
            <div className="text-center">
              <button
                className="modal__close opacity-50"
                onClick={this.closeModal}
              >
                <i className="material-icons">close</i>
              </button>
              <h3 className="text-gray-600 mb-2">
                Meet the team from workforce.com{" "}
                <span className="text-sm" role="img" aria-label="poiting down">
                  👇
                </span>
              </h3>
              <p className="flex mx-auto px-2 text-base sm:text-lg mb-0 text-gray-600">
                Watch how we&apos;re building the future of workforce
                management. Sign up for a free trial
                <SignUpBtn
                  country={this.state.country}
                  action="button"
                  cta="here."
                  theme="px-1 -mt-3 text-base sm:text-lg mb-0 text-blue-light"
                ></SignUpBtn>
              </p>
              <div className="player-wrapper mb-8 mt-4 shadow-xl">
                <ReactPlayer
                  className="absolute top-0 left-0 right-0"
                  url="https://www.youtube.com/watch?v=h7uldcdS-Dw"
                  playing={this.state.player}
                  width="100%"
                  height="100%"
                  controls
                  onStart={() =>
                    trackVideoWatch(`homepage-modal-${this.state.country}`)
                  }
                />
              </div>
              <p className="px-2 text-base mb-4 text-gray-600 flex flex-wrap items-center justify-center">
                <a
                  href="https://www.youtube.com/channel/UCpDoOWR212YK3D_7Iyve3pQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-300 text-white icon__social h-8 w-8 rounded-full inline-flex items-center justify-center mx-2"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <span className="mt-2 sm:mt-0">
                  For more videos, please visit
                </span>
                <Link className="link link__blue mx-1 text-base" to="/videos">
                  {" "}
                  Workforce Videos
                </Link>
              </p>
            </div>
          </Modal>
          <Metatags
            title="#1 Workforce Management Software | Workforce.com"
            description="The leading workforce management software for employee scheduling, time & attendance, legal compliance, & more."
            image="/images/software/header-image-homepage.png"
          />
          {this.state.country === "us" ? (
            <ParallaxProvider>
              <header className=" background__gradient__blue pt-20 lg:pt-48">
                <div className="max-w-6xl flex flex-wrap pb-32 items-center mx-auto">
                  <div className="w-full lg:w-2/5 xl:w-1/2 order-2 lg:order-1">
                    <h5 className="font-normal text-gray-600 text-center lg:text-left">
                      WORKFORCE MANAGEMENT SOFTWARE
                    </h5>
                    <h1 className="text-blue-dark text-center lg:text-left">
                      Everything you need for workforce management
                    </h1>
                    <p className="px-2 text-base sm:text-lg md:text-xl text-center lg:text-left text-gray-500 mb-8 max-w-lg mx-auto lg:mx-0">
                      Save on labor costs, automatically comply with labor laws,
                      and more. All in an online solution that’s easy to use for
                      you and your employees.
                    </p>
                    <div className="px-2 flex justify-center lg:justify-start">
                      <div className="inline-block">
                        <Chillipiperbtn country={this.state.country} />
                        <button
                          onClick={this.openModal}
                          className="btn btn__blue btn__outline"
                        >
                          About Us
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-3/5 xl:w-1/2 order-1 lg:order-2">
                    <div
                      className={`player-wrapper player-wrapper-xl relative ${
                        this.state.country === "uk" ? "" : "rounded-none"
                      } mb-8 lg:mb-0`}
                    >
                      <ReactPlayer
                        className="absolute left-0 top-0 software__video"
                        url="https://www.youtube.com/watch?v=monRhsgJ5lw"
                        playing
                        width="100%"
                        height="100%"
                        controls
                        light="/images/software/header.png"
                        playIcon={
                          <FontAwesomeIcon
                            className="text-6xl lg:ml-32"
                            icon={faYoutube}
                          />
                        }
                        onStart={() =>
                          trackVideoWatch(
                            `homepage-overview-${this.state.country}`
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <h3 className="text-blue-dark text-center">
                  Workforce.com customers manage over 300,000 shift workers
                  worldwide
                </h3>
                <div className="logos__slide my-8"></div>
              </header>

              <section className="py-16 px-2 container text-left">
                <div className="relative flex flex-wrap justify-center items-center">
                  <div className="md:px-4 lg:px-16 w-full lg:w-1/2 order-2 relative">
                    <div className="my-8">
                      <h2 className="text-gray-600 font-normal">
                        Employee scheduling
                      </h2>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Workforce.com forecasts your business’s needs so you can
                        create optimal schedules based on demand.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Build employee schedules in just a few clicks with the
                        auto-scheduler and drag-and-drop tools.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Easily manage shift swaps and time-off right inside the
                        tool. Employees can see up-to-date schedules in the
                        Workforce.com app.
                      </p>
                      <Link
                        to="/software/scheduling-software"
                        className="text-base sm:text-lg md:text-xl mx-2 mt-8 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about employee scheduling
                      </Link>
                    </div>
                  </div>
                  <div className="px-6 mb-2 w-full lg:w-1/2 flex flex-col order-1">
                    <OptimisedImage
                      className="block mx-auto"
                      src="/images/software/employee.png"
                      alt=""
                    />
                  </div>
                </div>
              </section>

              <section className="py-8 px-2 container text-left">
                <div className="relative flex flex-wrap justify-center items-center">
                  <div className="md:px-4 lg:px-16 w-full lg:w-1/2 order-2 lg:order-1 relative">
                    <div className="my-8">
                      <h2 className="text-gray-600 font-normal">
                        Time and attendance tracking
                      </h2>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        No more paperwork or clunky time clock equipment.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Employees can clock in and out from anywhere with the
                        Workforce.com mobile app.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        You’ll get 100% accurate electronic timesheets and avoid
                        buddy punching with unique employee passcodes, photo
                        verification, and GPS location data.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Export to your payroll system with just a few clicks.
                      </p>
                      <Link
                        to="/software/time-and-attendance"
                        className="text-base sm:text-lg md:text-xl mx-2 mt-8 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about time and attendance tracking
                      </Link>
                    </div>
                  </div>
                  <div className="relative px-6 mb-2 w-full lg:w-1/2 flex flex-col order-1 lg:order-2">
                    <Parallax className="" y={[-5, 5]} tagOuter="figure">
                      <OptimisedImage
                        className="block mx-auto max-w-sm"
                        src="/images/software/time.png"
                        alt=""
                      />
                    </Parallax>
                    <OptimisedImage
                      className="block mx-auto w-136 -mr-16 right-0 absolute z-negative opacity-50 lg:opacity-100"
                      src="/images/software/dot-bg.png"
                      alt=""
                    />
                  </div>
                </div>
              </section>

              <section className="py-16 px-2 text-left bg-blue-100">
                <div className="relative flex container flex-wrap justify-center items-center">
                  <div className="md:px-4 lg:px-16 w-full lg:w-1/2 order-2 relative">
                    <div className="my-8">
                      <h2 className="text-gray-600 font-normal">
                        Real-time analytics and reporting
                      </h2>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Get a snapshot of your business in one real-time,
                        customizable dashboard.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Quickly understand key data like labor costs and hours
                        by location and roles.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Easily drill down to see where you may be overspending
                        and why.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Generate reports for your important stakeholders.
                      </p>
                      <Link
                        to="/software/workforce-analytics"
                        className="text-base sm:text-lg md:text-xl mx-2 mt-8 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about workforce analytics
                      </Link>
                    </div>
                  </div>
                  <div className="px-6 mb-2 w-full lg:w-1/2 flex flex-col order-1">
                    <OptimisedImage
                      className="block mx-auto"
                      src="/images/software/real-time.png"
                      alt=""
                    />
                  </div>
                </div>
              </section>

              <section className="py-8 px-2 container text-left">
                <div className="relative flex flex-wrap justify-center items-center">
                  <div className="md:px-4 lg:px-16 w-full lg:w-1/2 order-2 lg:order-1 relative">
                    <div className="my-8">
                      <h2 className="text-gray-600 font-normal">
                        Labor compliance
                      </h2>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Never worry about violating federal, state, and local
                        labor regulations.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Workforce.com automates labor compliance, whether you
                        need to avoid clopenings, provide sufficient breaks, or
                        meet fair workweek standards.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        From scheduling to payroll, the platform flags any
                        potential compliance risk.
                      </p>
                      <Link
                        to="/software/wage-and-hour-compliance"
                        className="text-base sm:text-lg md:text-xl mx-2 mt-8 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about labor compliance
                      </Link>
                    </div>
                  </div>
                  <div className="px-6 mb-2 w-full lg:w-1/2 flex flex-col order-1 lg:order-2">
                    <OptimisedImage
                      className="block mx-auto"
                      src="/images/software/labor.png"
                      alt=""
                    />
                  </div>
                </div>
              </section>

              <section className="py-8 px-2 container">
                <h2 className="text-gray-600 text-center font-normal">
                  Get your team on Workforce.com in record time
                </h2>
                <div className="relative flex flex-wrap justify-center items-center max-w-4xl my-8 lg:my-24 mx-auto">
                  <div className="w-full lg:w-1/2 order-2 relative">
                    <div className="my-8">
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Implementation takes weeks, not months, so you can see
                        improvements in schedules, labor costs, and team
                        communication quickly.
                      </p>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 pb-4">
                        Our team takes care of integrating the platform with
                        your existing systems. We walk you through the
                        implementation so that you and your team can use the
                        platform in no time.
                      </p>
                    </div>
                  </div>
                  <div className="relative px-6 mb-2 w-full lg:w-1/2 flex flex-col order-1">
                    <OptimisedImage
                      className="block mx-auto w-80"
                      src="/images/software/get.png"
                      alt=""
                    />
                    <OptimisedImage
                      className="block mx-auto w-176 -ml-80 mt-20 left-0 absolute z-negative"
                      src="/images/software/dot-bg.png"
                      alt=""
                    />
                  </div>
                </div>
                <Parallax className="" y={[20, -20]} tagOuter="figure">
                  <div className="max-w-6xl mx-auto shadow-2xl rounded-lg px-8 py-16 bg-white relative z-10">
                    <div className="max-w-4xl mx-auto">
                      <div className="text-center">
                        <OptimisedImage
                          className="flex justify-center mx-auto w-20 m-4"
                          src="/images/software/testimonial.png"
                          alt=""
                        />
                        <p className="px-2 text-base sm:text-lg md:text-xl font-bold text-blue-legacy">
                          Aerie Albaz
                        </p>
                        <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                          COO, Domino’s Israel
                        </p>
                        <blockquote className="text-blue-light text-lg md:text-xl lg:text-2xl max-w-2xl mx-auto pt-8 pb-16">
                          “For me, it’s a revolution. Implementation was very
                          good, and in two weeks we have trained everyone to use
                          the platform. We saw good progress in the efficiency
                          of our stores.”
                        </blockquote>
                      </div>

                      <hr className="pb-8 border-gray-200 border-t-2" />

                      <ul className="flex flex-wrap lg:flex-no-wrap justify-center">
                        <li className="w-full md:w-56 xl:w-1/4 my-2">
                          <div className="relative overflow-hidden flex md:inline-block xl:flex text-white p-4 h-full items-start justify-center">
                            <span className="text-blue-light opacity-50 material-icons material-icons--rounded text-6xl transform -rotate-90 scale-100">
                              forward
                            </span>
                            <div className="pl-4">
                              <p className=" text-5xl text-blue-light leading-tight relative z-10">
                                11%
                              </p>
                              <p className="px-2 text-base text-gray-300">
                                increase in productivity
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="w-full md:w-56 xl:w-1/4 my-2">
                          <div className="relative overflow-hidden flex md:inline-block xl:flex text-white p-4 h-full items-start justify-center">
                            <span className="text-blue-light opacity-50 material-icons material-icons--rounded text-6xl transform rotate-90 scale-100">
                              forward
                            </span>
                            <div className="pl-4">
                              <p className="text-5xl text-blue-light leading-tight relative z-10">
                                4%
                              </p>
                              <p className="px-2 text-base text-gray-300">
                                decrease in total wages
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="w-full md:w-56 xl:w-1/4 my-2">
                          <div className="relative overflow-hidden flex md:inline-block xl:flex text-white p-4 h-full items-start justify-center">
                            <span className="text-blue-light opacity-50 material-icons material-icons--rounded text-6xl transform rotate-90 scale-100">
                              forward
                            </span>
                            <div className="pl-4">
                              <p className=" text-5xl text-blue-light leading-tight relative z-10">
                                3.5%
                              </p>
                              <p className="px-2 text-base text-gray-300">
                                decrease in total hours
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="w-full lg:w-56 xl:w-1/4 my-2 flex items-center justify-center">
                          <Link
                            to="/news/wfm-technology-saves-valuable-time-and-money-for-dominos-israel"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-base sm:text-lg mx-2 link link__arrow link__blue flex justify-center sm:justify-start border-gray-200 border rounded-md p-4 border-solid"
                          >
                            See the Case Study
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Parallax>
              </section>

              <section className="pt-24 pb-48 text-center">
                <h2 className="text-blue-dark">
                  What else you get with Workforce.com
                </h2>
                <div className="max-w-6xl mx-auto flex flex-wrap text-left justify-center mt-12">
                  <div className="w-full md:w-1/3 mb-12 px-6">
                    <div className="flex flex-wrap items-center">
                      <OptimisedImage
                        className="flex py-1 h-12 w-12 m-2"
                        src="/images/software/what-else-icon1.png"
                        alt=""
                      />
                      <h4 className="font-normal m-0">Mobile App</h4>
                    </div>

                    <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                      You and your employees can access the platform on any
                      mobile device. View schedules, approve leave requests,
                      make shift swaps, and more.
                    </p>
                  </div>
                  <div className="w-full md:w-1/3 mb-12 px-6">
                    <div className="flex flex-wrap items-center">
                      <OptimisedImage
                        className="flex py-1 h-12 w-12 m-2"
                        src="/images/software/what-else-icon2.png"
                        alt=""
                      />
                      <h4 className="font-normal m-0">
                        API &amp; Integrations
                      </h4>
                    </div>

                    <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                      Workforce.com integrates with your existing systems for
                      better staffing forecasts and seamless payroll processing.
                    </p>
                  </div>
                  <div className="w-full md:w-1/3 mb-12 px-6">
                    <div className="flex flex-wrap items-center">
                      <OptimisedImage
                        className="flex py-1 h-12 w-12 m-2"
                        src="/images/software/what-else-icon3.png"
                        alt=""
                      />
                      <h4 className="font-normal m-0">Customization</h4>
                    </div>

                    <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                      Set custom pay rates and rules that follow union
                      agreements. Customize dashboards to show the information
                      most important to your organization.
                    </p>
                  </div>
                  <div className="w-full md:w-1/3 mb-12 px-6">
                    <div className="flex flex-wrap items-center">
                      <OptimisedImage
                        className="flex py-1 h-12 w-12 m-2"
                        src="/images/software/what-else-icon4.png"
                        alt=""
                      />
                      <h4 className="font-normal m-0">Employee feedback</h4>
                    </div>

                    <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                      With the Workforce.com mobile app, you can get insights
                      about your operations straight from your teams using shift
                      rating, shift questions, and instant messaging.
                    </p>
                  </div>
                  <div className="w-full md:w-1/3 mb-12 px-6">
                    <div className="flex flex-wrap items-center">
                      <OptimisedImage
                        className="flex py-1 h-12 w-12 m-2"
                        src="/images/software/what-else-icon5.png"
                        alt=""
                      />
                      <h4 className="font-normal m-0">24/7 support</h4>
                    </div>

                    <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                      Contact our support team any time via chat or email. Every
                      enterprise customer gets a dedicated account manager.
                    </p>
                  </div>
                </div>
              </section>

              <section className="py-8 px-2 container mb-20">
                <div className="flex flex-wrap text-white">
                  <div className="w-full lg:w-1/2 px-4 relative">
                    <Parallax className="" y={[40, -40]} tagOuter="figure">
                      <OptimisedImage
                        className="block mx-auto w-32 -mt-24 mb-32"
                        src="/images/software/quote.png"
                        alt=""
                      />
                    </Parallax>
                    <OptimisedImage
                      className="block mx-auto w-176 -mt-80 ml-20 left-0 absolute z-negative"
                      src="/images/software/dot-bg.png"
                      alt=""
                    />
                    <div className="bg-blue-dark px-16 py-24 rounded-lg">
                      <blockquote className=" text-lg md:text-xl lg:text-2xl">
                        <i>
                          “It has just freed up so much time for my leaders to
                          be able to actually focus on the projects that make us
                          money and are better for the business, rather than
                          sitting there putting spreadsheets together, trying to
                          figure out what labor is going to cost.”
                        </i>
                      </blockquote>
                      <div className="flex flex-wrap items-center mt-8">
                        <OptimisedImage
                          className="flex py-1 h-20 w-20"
                          src="/images/software/chris.png"
                          alt=""
                        />
                        <div className="w-4/5">
                          <p className="px-2 text-base sm:text-lg md:text-xl font-bold">
                            Chris Tankard
                          </p>
                          <p className="px-2 text-base sm:text-lg md:text-xl">
                            Culture and Human Resources Manager Ferguson Plarre
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-1/2 px-4 lg:-mt-48">
                    <div className="bg-blue-light p-16 rounded-lg mb-8 mt-8">
                      <blockquote className=" text-lg md:text-xl lg:text-2xl">
                        <i>
                          “Workforce.com relieves me of the handwritten
                          schedules and saves me a lot of time pre-payroll as
                          well. It has also helped our payroll department save a
                          significant amount of time.”
                        </i>
                      </blockquote>
                      <div className="flex flex-wrap items-center mt-8">
                        <OptimisedImage
                          className="flex py-1 h-20 w-20"
                          src="/images/software/nallely.png"
                          alt=""
                        />
                        <div className="w-4/5">
                          <p className="px-2 text-base sm:text-lg md:text-xl font-bold">
                            Nallely Yearwood
                          </p>
                          <p className="px-2 text-base sm:text-lg md:text-xl">
                            Executive Director, Hearing Care Solutions
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-blue-legacy p-16 rounded-lg">
                      <blockquote className=" text-lg md:text-xl lg:text-2xl">
                        <i>
                          “Love being able to log in from anywhere and see who’s
                          there — exactly when they got there, when they came,
                          when they left, when they took their break or didn’t
                          take their break at the right time. I’ve never seen it
                          before.”
                        </i>
                      </blockquote>
                      <div className="flex flex-wrap items-center mt-8">
                        <OptimisedImage
                          className="flex py-1 h-20 w-20"
                          src="/images/software/dickie.png"
                          alt=""
                        />
                        <div className="w-4/5">
                          <p className="px-2 text-base sm:text-lg md:text-xl font-bold">
                            Dickie O’Reilly
                          </p>
                          <p className="px-2 text-base sm:text-lg md:text-xl">
                            Managing Partner, Spyder
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="container">
                <div className="text-center border-t border-b border-gray-200 pt-16 pb-24">
                  <h2 className="max-w-5xl mx-auto">
                    Get started with Workforce.com
                  </h2>
                  <p className="max-w-3xl mx-auto mt-4 px-2 text-base sm:text-lg md:text-xl mb-8 text-gray-500">
                    Comprehensive workforce management doesn’t have to be
                    complicated. Stay on top of it all with the world’s #1
                    workforce management platform.
                  </p>
                  <div className="flex justify-center">
                    <div className="btn__pair relative flex max-w-md justify-center">
                      <Chillipiperbtn country="us" />
                      <SignUpBtn
                        country={this.state.country}
                        action="button"
                        theme="btn__blue btn__outline mt-6 mb-0"
                      ></SignUpBtn>
                    </div>
                  </div>
                </div>
              </section>
            </ParallaxProvider>
          ) : (
            <>
              <header className="pt-20 lg:pt-48">
                <div className="max-w-6xl flex flex-wrap pb-32 items-center mx-auto">
                  <div className="w-full lg:w-2/5 xl:w-1/2 order-2 lg:order-1">
                    <h1 className="text-blue-dark text-center lg:text-left">
                      A new kind of workforce management.
                    </h1>
                    <p className="px-2 text-base sm:text-lg md:text-xl text-center lg:text-left text-gray-500 mb-8 max-w-lg mx-auto lg:mx-0">
                      Advanced scheduling, time & attendance, employee
                      engagement and automated labor compliance
                    </p>
                    <div className="px-2 flex justify-center lg:justify-start">
                      <div className="inline-block">
                        <Chillipiperbtn country={this.state.country} />
                        <button
                          onClick={this.openModal}
                          className="btn btn__blue btn__outline"
                        >
                          About Us
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-3/5 xl:w-1/2 order-1 lg:order-2">
                    <div
                      className={`player-wrapper relative ${
                        this.state.country === "uk" ? "" : "rounded-none"
                      } mb-8 lg:mb-0`}
                    >
                      <span className="text"></span>
                      <ReactPlayer
                        className="absolute left-0 top-0 software__video"
                        url="https://www.youtube.com/watch?v=monRhsgJ5lw"
                        playing
                        width="100%"
                        height="100%"
                        controls
                        light="/images/software/header-image-homepage.png"
                        playIcon={
                          <FontAwesomeIcon
                            className="text-6xl lg:ml-32"
                            icon={faYoutube}
                          />
                        }
                        onStart={() =>
                          trackVideoWatch(
                            `homepage-overview-${this.state.country}`
                          )
                        }
                      />
                      <span className="arrow"></span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap items-center justify-center max-w-6xl mx-auto mb-24 lg:mb-10 z-10 relative software__partners">
                  {apps.map((value, index) => {
                    return (
                      <OptimisedImage
                        key={index}
                        src={value.image}
                        alt={value.title}
                        className={`w-1/3 sm:w-1/8 my-4 mx-auto p-2 object-center object-contain h-12 flex justify-center ${
                          value.class ? value.class : ""
                        }`}
                      />
                    );
                  })}
                </div>
              </header>

              <span className="block relative bg-white bg__top__curve bg__top__left__curve"></span>
              <section className="bg-blue-100">
                <div className="container pb-48 pt-56">
                  <ul className="flex flex-wrap lg:flex-no-wrap justify-center absolute -mt-64 lg:-mt-56 xl:-mt-40 left-0 right-0 max-w-5xl mx-auto">
                    <li className="w-full md:w-56 xl:w-1/4 my-2">
                      <div className="relative overflow-hidden flex md:inline-block xl:flex bg-blue-legacy text-white p-4 mx-4 rounded-md shadow-lg h-full items-center justify-center">
                        <OptimisedImage
                          className="absolute right-0 top-0 -mt-6 -mr-6"
                          src="/images/home/dots-bg.png"
                          alt=""
                        />
                        <span className="result__icon material-icons material-icons--rounded text-6xl transform -rotate-90 scale-150">
                          forward
                        </span>
                        <div className="pl-4">
                          <p className=" text-5xl font-bold leading-tight relative z-10">
                            11%
                          </p>
                          <p className="px-2 text-base">
                            increase in productivity
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="w-full md:w-56 xl:w-1/4 my-2">
                      <div className="relative overflow-hidden flex md:inline-block xl:flex bg-blue-legacy text-white p-4 mx-4 rounded-md shadow-lg h-full items-center justify-center">
                        <OptimisedImage
                          className="absolute right-0 top-0 -mt-6 -mr-6"
                          src="/images/home/dots-bg.png"
                          alt=""
                        />
                        <span className="result__icon material-icons material-icons--rounded text-6xl transform rotate-90 scale-150">
                          forward
                        </span>
                        <div className="pl-4">
                          <p className="text-5xl font-bold leading-tight relative z-10">
                            4%
                          </p>
                          <p className="px-2 text-base">
                            decrease in total wages
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="w-full md:w-56 xl:w-1/4 my-2">
                      <div className="relative overflow-hidden flex md:inline-block xl:flex bg-blue-legacy text-white p-4 mx-4 rounded-md shadow-lg h-full items-center justify-center">
                        <OptimisedImage
                          className="absolute right-0 top-0 -mt-6 -mr-6"
                          src="/images/home/dots-bg.png"
                          alt=""
                        />
                        <span className="result__icon material-icons material-icons--rounded text-6xl transform rotate-90 scale-150">
                          forward
                        </span>
                        <div className="pl-4">
                          <p className=" text-5xl font-bold leading-tight relative z-10">
                            3.5%
                          </p>
                          <p className="px-2 text-base">
                            decrease in total hours
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="w-full lg:w-auto xl:w-1/5 my-2">
                      <a
                        href="../files/WorkforceCaseStudy_DominosIsrael.pdf"
                        id="download_results"
                        download
                        onClick={() =>
                          trackButtonClick(
                            `homepage-casestudy-download-${this.state.country}`
                          )
                        }
                        className="block lg:flex lg:flex-col lg:justify-center text-center border-blue-legacy border border-solid text-blue-legacy py-4 px-8 mx-4 rounded-md h-full bg-white"
                      >
                        <span className="material-icons text-6xl">get_app</span>
                        <p className="px-2 text-base sm:text-lg">
                          Download Case Study
                        </p>
                      </a>
                    </li>
                  </ul>
                  <div className="text-center max-w-3xl mx-auto mt-120 lg:mt-40">
                    <h4 className="text-blue-dark font-normal">
                      The Workforce.com Platform
                    </h4>
                    <h2 className="text-blue-dark ">
                      Cut down on admin and empower your team
                    </h2>
                  </div>
                  <div className="flex flex-wrap items-center bg__software__schedule relative">
                    <div className="w-full sm:w-1/2 relative z-10">
                      <EmbeddedVideo
                        path="/images/software/software-scheduling.webm"
                        fallBackImgPath="/images/software/software-scheduling.png"
                        type="video/webm"
                      />
                    </div>
                    <div className="w-full sm:w-1/2">
                      <h3 className="text-blue-dark font-normal text-center sm:text-left">
                        Build your employee schedules in seconds
                      </h3>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-8 text-center sm:text-left">
                        Create detailed shift schedules based on locations and
                        teams with our simple online employee scheduling tool
                      </p>
                      <Link
                        to={`${
                          this.state.country === "uk"
                            ? "/uk/software/rota"
                            : "/software/scheduling-software"
                        }`}
                        className="text-base sm:text-lg md:text-xl mx-2 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about Scheduling Software
                      </Link>
                    </div>
                  </div>
                </div>
              </section>
              <span className="block relative bg-white bg__bottom__curve bg__bottom__left__curve"></span>

              <section>
                <div className="container pb-32">
                  <div className="flex flex-wrap justify-center relative sm:flex-col sm:h-120 lg:h-104">
                    <div className="w-full sm:w-1/2 order-1 text-center sm:text-left">
                      <h3 className="text-blue-dark font-normal">
                        {" "}
                        Send shift schedules via our Mobile App
                      </h3>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-8">
                        Send schedule to your staff via SMS and/or email so
                        everyone can check their schedules anywhere they are
                      </p>
                    </div>

                    <div className="w-full sm:w-1/2 order-3 sm:order-2">
                      <Link
                        to={`${
                          this.state.country === "uk" ? "/uk" : ""
                        }/software/employee-app`}
                        className="text-base sm:text-lg md:text-xl mx-2 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about the Employee App
                      </Link>
                    </div>

                    <div
                      className="w-full sm:w-1/2 order-2 bg__software__shift"
                      dir="ltr"
                    >
                      <EmbeddedVideo
                        path="/images/software/software-mobile.webm"
                        fallBackImgPath="/images/software/software-mobile.png"
                        type="video/webm"
                      />
                    </div>
                  </div>
                </div>
              </section>
              <section className="bg-blue-100">
                <div className="container py-24">
                  <div className="flex flex-wrap justify-center relative sm:flex-col sm:h-120 lg:h-104">
                    <div className="w-full sm:w-1/2 order-1 sm:order-2 text-center sm:text-left">
                      <h3 className="text-blue-dark font-normal">
                        {" "}
                        Start Clocking In
                      </h3>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-8">
                        Download the Workforce Time Clock mobile app so your
                        staff can easily clock in/out of their shifts. Photo
                        verified, accurate times, no buddy punches, no paper
                        timesheets, no expensive hardware & GPS enabled.
                      </p>
                    </div>

                    <div className="w-full sm:w-1/2 order-3">
                      <Link
                        to={`${
                          this.state.country === "uk" ? "/uk" : ""
                        }/software/timeclock-app`}
                        className="text-base sm:text-lg md:text-xl mx-2 link link__arrow link__blue flex justify-center sm:justify-start"
                      >
                        Learn more about the Timeclock App
                      </Link>
                    </div>

                    <div
                      className="w-full sm:w-1/2 order-2 sm:order-1"
                      dir="ltr"
                    >
                      <EmbeddedVideo
                        path="/images/software/software-timeclock.webm"
                        fallBackImgPath="/images/software/software-timeclock.png"
                        type="video/webm"
                      />
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <div className="container pt-24">
                  <div className="flex flex-wrap justify-center relative sm:flex-col sm:h-104 lg:h-104">
                    <div className="w-full sm:w-1/2 order-1 text-center sm:text-left">
                      <h3 className="text-blue-dark font-normal">
                        {" "}
                        Automate Timesheets
                      </h3>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        When staff clock in, the time clock records the exact
                        times they worked.
                      </p>
                    </div>

                    <div className="w-full sm:w-1/2 order-3 sm:order-2">
                      <div className="px-2 flex justify-center sm:justify-start">
                        <SignUpBtn
                          country={this.state.country}
                          action="button"
                          cta="Get Started"
                          theme="mt-6 mb-0 btn__solid btn__orange"
                        ></SignUpBtn>
                      </div>
                    </div>

                    <div className="w-full sm:w-1/2 order-2" dir="ltr">
                      <EmbeddedVideo
                        path="/images/software/software-timesheets.webm"
                        fallBackImgPath="/images/software/software-timesheets.png"
                        type="video/webm"
                      />
                    </div>
                  </div>
                </div>
              </section>
              <span className="block relative bg-white bg__top__curve bg__top__right__curve"></span>
              <section className="bg-blue-100">
                <div className="container py-48">
                  <div className="flex flex-wrap items-center">
                    <div className="w-full sm:w-1/2 relative z-10">
                      <EmbeddedVideo
                        path="/images/software/software-payroll.webm"
                        fallBackImgPath="/images/software/software-payroll.png"
                        type="video/webm"
                      />
                    </div>
                    <div className="w-full sm:w-1/2 text-center sm:text-left bg__software__staff relative">
                      <h3 className="text-blue-dark font-normal">
                        Workforce Compliance
                      </h3>
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-8">
                        Preconfigured for all national, state and county labor
                        laws. Integrate with your existing HCM & Payroll systems
                        for seamless workforce automation
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <span className="block relative bg-white bg__bottom__curve bg__bottom__right__curve"></span>
              <section>
                <div className="container">
                  <h2 className="text-center mb-8 text-blue-dark">
                    More ways to get the job done
                  </h2>
                  <div className="flex flex-wrap">
                    <div className="w-full sm:w-1/2 md:w-1/4 px-4 py-4">
                      <OptimisedImage
                        style={{ maxWidth: "50px" }}
                        className="block m-2 w-12"
                        src="/images/features/icons/loop-live-wage-tracker.gif"
                        alt=""
                      />
                      <h5 className="text-blue-dark">Live Wage Tracker</h5>
                      <p className="px-2 text-gray-500">
                        See who&apos;s at work and what it&apos;s costing right
                        now.
                      </p>
                      <Link
                        className="mx-2 mt-4 inline-block text-base link link__arrow link__blue link__underline"
                        to="/uk/software/livewage-tracker"
                        title="Employee Time Clock"
                      >
                        Learn About Wage Tracking
                      </Link>
                    </div>
                    <div className="w-full sm:w-1/2 md:w-1/4 px-4 py-4">
                      <OptimisedImage
                        style={{ maxWidth: "50px" }}
                        className="block m-2 w-12"
                        src="/images/features/icons/loop-gps-clockin.gif"
                        alt=""
                      />
                      <h5 className="text-blue-dark">GPS Clock-ins</h5>
                      <p className="px-2 text-gray-500">
                        Contactless time & attendance with GPS verification.
                      </p>
                      <Link
                        className="mx-2 mt-4 inline-block text-base link link__arrow link__blue link__underline"
                        to="/uk/software/timeclock-app"
                        title="Employee Time Clock"
                      >
                        Learn About Timeclock App
                      </Link>
                    </div>
                    <div className="w-full sm:w-1/2 md:w-1/4 px-4 py-4">
                      <OptimisedImage
                        style={{ maxWidth: "50px" }}
                        className="block m-2 w-12"
                        src="/images/features/icons/loop-leave-and-unavailability.gif"
                        alt=""
                      />
                      <div>
                        <h5 className="text-blue-dark">Time Off</h5>
                        <p className="px-2 text-gray-500">
                          Accept & approve time off requests in one platform,
                          then export to payroll/HR.
                        </p>
                      </div>
                      <Link
                        className="mx-2 mt-4 inline-block text-base link link__arrow link__blue link__underline"
                        to="/uk/software/leave-and-unavailability"
                        title="Employee Time Clock"
                      >
                        Learn About PTO Integration
                      </Link>
                    </div>
                    <div className="w-full sm:w-1/2 md:w-1/4 px-4 py-4">
                      <OptimisedImage
                        style={{ maxWidth: "50px" }}
                        className="block m-2 w-16"
                        src="/images/features/icons/loop-shift-swapping.gif"
                        alt=""
                      />
                      <h5 className="text-blue-dark">Shift Swapping</h5>
                      <p className="px-2 text-gray-500">
                        Let employees swap shifts with manager approval & cost
                        verification.
                      </p>
                      <Link
                        className="mx-2 mt-4 inline-block text-base link link__arrow link__blue link__underline"
                        to="/uk/software/shift-swapping"
                        title="Employee Time Clock"
                      >
                        Learn About Swapping Management
                      </Link>
                    </div>
                  </div>
                </div>
              </section>
              <section className="mt-32">
                <span className="bg__software__industry"></span>
                <div className="flex items-center justify-center flex-col container mx-auto">
                  <div className="lg:mr-12 mb-8">
                    <h2 className="text-blue-dark mt-24 mb-3 text-center p-0">
                      Get industry insights and resources
                    </h2>
                  </div>
                  <div className="industries__tiles flex flex-col justify-center">
                    <div
                      className={`industries__tiles-div flex flex-wrap items-center ${
                        this.state.tilesVisible ? "active" : ""
                      }`}
                    >
                      {_.map(this.state.industries, (industry, index) => {
                        return (
                          <div
                            key={index}
                            className={`tile w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-4 ${
                              index ===
                                this.state.industries.length -
                                  (this.state.industries.length % 4) &&
                              this.state.industries.length % 2
                                ? "xl:ml-40"
                                : ""
                            }`}
                          >
                            <Link
                              to={"/uk/industry/" + industry.slug}
                              className="bg-white flex justify-center items-center w-full h-24 px-5 sm:px-9 shadow-md group rounded-md border-t-4 border-transparent hover:border-blue-light text-gray-400 hover:text-blue-light leading-none"
                            >
                              <OptimisedImage
                                src={industry.icon}
                                alt={industry.slug}
                                className="mr-3 tile__icon"
                              />
                              <p className="text-base sm:text-lg md:text-xl">
                                {industry.title}
                              </p>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                    <button
                      className="btn btn__outline btn__blue focus:outline-none mx-auto mt-3 block sm:hidden"
                      onClick={this.toggleTiles}
                    >
                      Show {this.state.tilesVisible ? "less" : "more"}
                    </button>
                  </div>
                </div>
              </section>
              <section>
                <div className="container py-24">
                  <div className="flex flex-wrap justify-center relative sm:flex-col sm:h-96 lg:h-96">
                    <div className="w-full sm:w-1/2 order-1 sm:order-2 text-center sm:text-left px-4">
                      <h2 className="text-blue-dark">
                        Dedicated account management & 24/7 support
                      </h2>
                    </div>

                    <div className="w-full sm:w-1/2 order-3 px-4">
                      <p className="px-2 text-base sm:text-lg md:text-xl text-gray-500 text-center sm:text-left">
                        Workforce.com enterprise customers get a dedicated
                        account manager, backed by a 24/7 support team. We
                        specialize in the Scaled Agile Framework (SAFe 5.0) and
                        focus on delivering value from implementation projects
                        in weeks, not years.
                      </p>
                    </div>

                    <div
                      className="w-full sm:w-1/2 order-2 sm:order-1 relative"
                      dir="ltr"
                    >
                      <div className="px-2 mb-16">
                        <div className="">
                          <OptimisedImage
                            src="/images/software/software-testimonial.jpg"
                            alt=""
                            className="max-w-md mx-auto w-full object-contain object-top py-4 software__contact"
                          />
                        </div>
                      </div>
                      <div className="absolute py-4 sm:py-8 pl-8 pr-0 sm:pl-12 sm:pr-4 right-0 bottom-0 mb-4 sm:-mb-6 mr-4 bg-white rounded-md shadow-lg w-56 sm:w-64">
                        <p>
                          {this.state.country === "uk"
                            ? "The Frames, 1 Phipp Street, London EC2A 4PS"
                            : "150 N Michigan Ave, Chicago, IL 60601"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* MARKETPLACE */}
              <section>
                <div className="text-center">
                  <h2 className="text-blue-dark">
                    Works with your HRIS & Payroll systems
                  </h2>
                  <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                    Workforce.com integrates with market leading HRIS & Payroll
                    systems, but doesn&apos;t replace them. It&apos;s a best of
                    breed system for WFM, that will drive ROI by specialising in
                    operational accountability and employee engagement.
                  </p>
                </div>
                {this.state.country === "uk" ? (
                  <Slider className="my-4" {...settings}>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/xero.png"
                          alt="Xero"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/intuit-quickbooks.png"
                          alt="Intuit Quickbooks"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/sage-micropay.png"
                          alt="Sage Micropay"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/Tenzo.png"
                          alt="Tenzo"
                          className="object-contain object-center flex justify-center h-8"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/goodtill.png"
                          alt="Goodtill"
                          className="object-contain object-center flex justify-center h-8"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/iKentoo.png"
                          alt="iKentoo"
                          className="object-contain object-center flex justify-center h-10"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/zettle.png"
                          alt="Zettle"
                          className="object-contain object-center flex justify-center h-8"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/Tevalis_800x500.png"
                          alt="Tevalis"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                  </Slider>
                ) : (
                  <Slider className="my-4" {...settings}>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/xero.png"
                          alt="Xero"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/adp-payforce.png"
                          alt="ADP Payforce"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/adp-run.png"
                          alt="ADP Run"
                          className="object-contain object-center flex justify-center h-12"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/adp-workforcenow.png"
                          alt="ADP"
                          className="object-contain object-center flex justify-center h-11"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/paychex.png"
                          alt="Paychex"
                          className="object-contain object-center flex justify-center h-6"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/square-payroll.png"
                          alt="Square"
                          className="object-contain object-center flex justify-center h-8"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/sage.png"
                          alt="Sage"
                          className="object-contain object-center flex justify-center h-8"
                        />
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center justify-center h-20 bg-white shadow-lg py-4 my-8 mx-2 lg:mx-8 rounded-full">
                        <OptimisedImage
                          src="/images/logos/gusto.png"
                          alt="Gusto"
                          className="object-contain object-center flex justify-center h-10"
                        />
                      </div>
                    </div>
                  </Slider>
                )}

                <div className="flex justify-center">
                  <Link
                    className="mx-2 inline-block text-base link link__arrow link__blue link__underline"
                    to="/uk/integrations"
                    title="HRIS Integrations"
                  >
                    All Integrations
                  </Link>
                </div>
              </section>

              {/* TESTIMONIAL */}
              <section className="my-32">
                <h2 className="px-3 text-blue-dark text-center">
                  Join more than 300,000 working on workforce.com worldwide
                </h2>
                <div className="container flex flex-wrap">
                  <div className="w-full md:w-1/2 lg:w-1/3 my-4">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/app-store.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        So thorough. Tells me everything that I need to know,
                        and more! The way it’s set out is so easy to read.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Sonia Brewer
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden md:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/app-store.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        Great app, makes my work schedule faster and easier to
                        manage due to this being my first time using a roster.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Tyrone Fraser
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden lg:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/app-store.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        Easy, versatile, clear and powerful for both employee
                        and employer sides of the work force. Highly
                        recommended.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        CoastalShack
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/google-play.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        Easy to use, clear and has some good functions like
                        notifying you of upcoming shifts needing to be filled.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Christopher Abbott
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden md:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/google-play.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        Super easy to use and great for small businesses, the
                        GPS feature is great for accountability.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Trey Boyett
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden lg:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/google-play.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        It provides a quick and easy way to check shifts and
                        apply for leave. Recommend to any manager or franchisee.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Rob&#39;s SA Fishing
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/capterra.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        Usability, Time clocks can be used at multiple location.
                        Easy to manage hours in correct and efficient manner.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Pankaj Kumar
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden md:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/capterra.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        It&#39;s efficiency on time and practicality. Its a
                        quick software to learn too!
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Rebecca Finch
                      </strong>
                    </div>
                  </div>

                  <div className="w-full md:w-1/2 lg:w-1/3 my-4 hidden lg:block">
                    <div className="h-full p-8 bg-white shadow-lg m-4 rounded-md testimonial__software__quote relative">
                      <div className="flex items-center mb-8 relative">
                        <div className="px-2">
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                          <span className="material-icons text-yellow">
                            star
                          </span>
                        </div>
                        <OptimisedImage
                          src="/images/logos/capterra.png"
                          alt="Xero"
                          className="object-contain object-center flex h-10 absolute right-0"
                        />
                      </div>
                      <p className="max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500 mb-4">
                        I am happy with the way it signs in and allows us to no
                        longer use a paper sign in sheet. We are using the very
                        basic set up, but for that its great.
                      </p>
                      <strong className="absolute bottom-0 mb-8 max-w-xl mx-auto px-2 text-base sm:text-lg md:text-xl text-gray-500">
                        Tanya Carlson
                      </strong>
                    </div>
                  </div>
                </div>
                <span className="bg__software__testimonial"></span>
                <div className="lg:mt-32 px-8">
                  <div className="bg-blue-dark rounded-md shadow-lg max-w-3xl mx-auto p-8 text-center">
                    <OptimisedImage
                      src="/images/software/footer-image-homepage.png"
                      alt=""
                      className="max-w-2xl mx-auto w-full object-contain object-top py-4 flex justify-center -mt-64 lg:-mt-104"
                    />
                    <h2 className="text-white">Start your free trial now</h2>
                    <div className="inline-block mx-2">
                      <SignUpBtn
                        action="button"
                        cta="Create Free Account"
                        theme="btn__solid btn__orange"
                        country={this.state.country}
                      ></SignUpBtn>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </div>
        <Footer />
      </>
    );
  }
}

export default Software;
